/* eslint-disable */
/**
 * Lightweight SEO helper — sets document.title and meta description without
 * needing an extra dependency (react-helmet-async).
 * On unmount it restores the previous values so navigating between pages
 * does not leak metadata from one route to the next.
 */
import { useEffect } from 'react';

function ensureMetaTag(name) {
  let el = document.head.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  return el;
}

export function usePageSeo({ title, description } = {}) {
  useEffect(() => {
    const prevTitle = document.title;
    const metaDesc = ensureMetaTag('description');
    const prevDesc = metaDesc.getAttribute('content') || '';

    if (title) document.title = title;
    if (description !== undefined && description !== null) {
      metaDesc.setAttribute('content', description);
    }

    return () => {
      document.title = prevTitle;
      metaDesc.setAttribute('content', prevDesc);
    };
  }, [title, description]);
}
